<footer>
    @if (systemParamsService.lightLogo()) {
        <img [src]="systemParamsService.lightLogo()" alt="department logo" class="logo" />
    } @else {
        <img src="./assets/logos/light-logo.png" alt="department logo" class="logo" />
    }
    <p>
        Copyright &copy; 2025 Australian Government - {{ systemParamsService.departmentName() }} (<span
            class="environment"
            >{{ environment() }}</span
        >)
    </p>
</footer>
